import { createContext, useContext } from 'react';
import type { AdvancedFilterConfig } from 'talent_matching/types';

const AdvancedFiltersContext = createContext<AdvancedFilterConfig>({
  filterGroups: [],
  currencies: [],
});

export const useAdvancedFiltersContext = () =>
  useContext(AdvancedFiltersContext);

export const AdvancedFiltersProvider = AdvancedFiltersContext.Provider;
